<template>
  <div class="DNSPage">
    <div class="dns-header">
      <span class="iconfont ys-iconbijibendiannaolaptop ys-common-iconFont"></span>&nbsp;&nbsp;&nbsp;
      <span class="ys-common-FontColor">DASHBOARD</span>
    </div>
    <div class="dns-hint ys-common-block-second">
      <div class="hintBody">
        <p>
          1. 以下对于解析规则的添加、修改、启用/禁用、删除等操作将立即生效。
        </p>
        <p>
          2. 解析规则的匹配优先级按照添加的顺序而定，先添加先匹配，如果有包含关系的解析规则（如example.com和test.example.com），请注意添加的次序。
        </p>
      </div>
    </div>
    <div class="dns-body">
      <!-- <iframe src="http://39.106.15.70:18080/xxl-job-admin/toLogin" frameborder="0" scrolling="auto"></iframe> -->
      <div class="body-header ys-common-block-second">
        <span class="ys-common-FontColor">域名解析设置</span>
        <Button class="ys-confirm" icon="ios-add" @click="handleAddClick">添加新条目</Button>
      </div>
      <div class="body-table" id="dnsTable">
        <el-table :columns="Columns" :tableData="tableData" :loading="tableLoading" :tableHeight="tableHeight"
          @on-btn-click="onBtnClick" @switch-change="SwitchChange">
        </el-table>
      </div>
      <div class="body-foote">
        <Page :total="totalCount" :current="pageNumber" :page-size="pageSize" @on-change="handlePagingClick" />
      </div>
    </div>
    <AddDNSInfoModal :IsOpenModal="IsOpenModal" :operationType="operationType" :EditDNSInfo="EditDNSInfo"
      @on-handleClick="OnHandleClick">
    </AddDNSInfoModal>
  </div>
</template>
<script>
  import {
    mapActions
  } from "vuex"
  import elementResizeDetectorMaker from "element-resize-detector"; // 获取元素的高度
  import ElTable from '_g/commonComponent/table/elTable.vue';
  import Columns from './tableConfig.js';
  import AddDNSInfoModal from "./AddDNSInfoModal"
  export default {
    name: "DNSPage",
    components: {
      'el-table': ElTable,
      AddDNSInfoModal
    },
    data() {
      return {
        tableData: [], // 数据
        Columns: [], // 表头
        totalCount: 0, // 总条数
        pageNumber: 1, // 当前页码
        pageSize: 12, // 每页显示条数
        tableHeight: 0, // 表格父级高度
        IsOpenModal: false, //是否打开弹框
        operationType: 1, // 操作类型 1新增  2编辑
        EditDNSInfo: {}, // 要编辑的信息
        tableLoading: true, // 表格loading
      }
    },
    mounted() {
      this.Columns = Columns;
      this.getDNSarr();
    },
    methods: {
      ...mapActions(["getDNSList", "setEnabled", "addDNSInfo", "updateDNSInfo", "removeDNSInfo"]),
      // 获取元素的高度
      getElementHeight() {
        let ERD = elementResizeDetectorMaker();
        let _this = this;
        ERD.listenTo(document.getElementById("dnsTable"), (element) => {
          _this.tableHeight = element.scrollHeight;
        });
      },
      // 获取DNS列表
      getDNSarr() {
        this.tableLoading = true;
        const params = new URLSearchParams();
        params.append('pageIndex', 1);
        this.getDNSList(params).then(res => {
          if (res.data.error.code == 0) {
            this.tableData = res.data.data.list;
          } else {
            this.$Message.error(res.data.error.reason);
          }
          this.tableLoading = false;
        }).catch(err => {
          this.$Message.error(err);
          this.tableLoading = false;
        });
      },
      // 开启或关闭
      SwitchChange(data) {
        const params = new URLSearchParams();
        params.append('ruleId', data.id);
        params.append('enabled', data.state);
        this.setEnabled(params).then(res => {
          if (res.data.error.code == 0) {
            this.$Message.success(data.state ? "开启成功" : "关闭成功");
            this.getDNSarr();
          } else {
            this.$Message.error(res.data.error.reason);
          }
        }).catch(err => {
          this.$Message.error(err);
        })
      },
      // 表格操作选项
      onBtnClick(rowItem, options) {
        switch (options.code) {
          case 1: // 编辑
            this.operationType = 2;
            this.IsOpenModal = true;
            this.EditDNSInfo = rowItem;
            this.EditDNSInfo["timeTo"] = this.ResetStr(this.EditDNSInfo["timeTo"]);
            this.EditDNSInfo["timeFrom"] = this.ResetStr(this.EditDNSInfo["timeFrom"]);
            break;
          default:
            // 删除
            this.deleteCDNInfo(rowItem.id)
            break;
        }
      },
      //新增条目打开弹框
      handleAddClick() {
        this.operationType = 1;
        this.IsOpenModal = true;
      },
      // 新增条目
      createCNDInfo(params) {
        this.addDNSInfo(params).then(res => {
          if (res.data.error.code == 0) {
            this.$Message.success("新增成功！");
            this.IsOpenModal = false;
            this.getDNSarr();
          } else {
            this.$Message.error(res.data.error.reason);
          }
        }).catch(err => {
          this.$Message.error(err);
        })
      },
      // 删除条目
      deleteCDNInfo(id) {
        const params = new URLSearchParams();
        params.append("ruleId", id);
        this.removeDNSInfo(params).then(res => {
          if (res.data.error.code == 0) {
            this.$Message.success("删除成功！");
            this.getDNSarr();
          } else {
            this.$Message.error(res.data.error.reason);
          }
        }).catch(err => {
          this.$Message.error(err);
        })
      },
      // 编辑条目
      editCDNInfo(params) {
        this.updateDNSInfo(params).then(res => {
          if (res.data.error.code == 0) {
            this.$Message.success("更新成功！");
            this.IsOpenModal = false;
            this.getDNSarr();
          } else {
            this.$Message.error(res.data.error.reason);
          }
        }).catch(err => {
          this.$Message.error(err);
        })
      },
      // 弹框确定取消按钮事件
      OnHandleClick(index, info = null) {
        // 取消
        if (index === 1) {
          this.IsOpenModal = false;
          return;
        } else {
          // 处理参数
          let paramslist = ["ipFrom", "ipTo", "timeFrom", "timeTo", "matchMode", "name", "dispatchMode", "addresses",
            "id"
          ];
          const params = new URLSearchParams();
          let infoKeys = Object.keys(info);
          for (let i = 0; i < infoKeys.length; i++) {
            if (paramslist.indexOf(infoKeys[i]) !== -1) {
              if (infoKeys[i] == "id") {
                params.append("ruleId", info[infoKeys[i]] == undefined ? null : info[infoKeys[i]]);
              } else {
                params.append(`${infoKeys[i]}`, info[infoKeys[i]] == undefined ? null : info[infoKeys[i]]);
              }
            }
          }
          // 1 新增  2 编辑
          if (this.operationType == 1) {
            this.createCNDInfo(params);
          } else {
            this.editCDNInfo(params);
          }
        }
      },
      // 处理时间信息
      ResetStr(strinfo) {
        let hour = "";
        let minute = "";
        let second = "";
        strinfo = strinfo == null ? "" : strinfo.toString();
        if (strinfo.length <= 5) {
          hour = "0" + strinfo.substr(0, 1).toString();
          minute = strinfo.substr(1, 2).toString();
          second = strinfo.substr(3).toString();
        } else {
          hour = strinfo.substr(0, 2);
          minute = strinfo.substr(2, 2);
          second = strinfo.substr(4);
        }
        let resStrInfo = `${hour}:${minute}:${second}`;
        return resStrInfo;
      }
    }
  }
</script>
<style lang="less" scoped>
  .DNSPage {
    width: 100%;
    height: 100%;
    padding: 10px 15px;
    overflow-y: auto;

    .dns {
      &-header {
        width: 100%;
        height: 60px;
        display: flex;
        align-items: center;

        &>span:first-child {
          font-size: 40px;
        }

        &>span:last-child {
          font-size: 24px;
          font-weight: 300;
          letter-spacing: -1px;
        }
      }

      &-hint {
        width: 100%;
        height: 100px;
        padding: 15px;
        margin-bottom: 15px;

        .hintBody {
          height: 100%;
          width: 100%;
          background: #feefd2;
          color: #b37905;
          font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
          font-size: 14px;
          padding: 15px 30px;
        }
      }

      &-body {
        width: 100%;
        height: calc(100% - 175px);

        &>iframe {
          width: 100%;
          height: 100%;
          // border: 1px solid red;
        }

        .body-header {
          height: 35px;
          line-height: 35px;
          width: 100%;
          padding: 0 30px;
          box-shadow: 0px 2px 2px 0px black;

          &>span {
            font-size: 14px;
            font-weight: 600;
          }

          button {
            height: 35px;
            float: right;
          }
        }

        .body-table {
          height: calc(100% - 75px);
          width: 100%;
        }

        .body-foote {
          height: 40px;
          width: 100%;
          position: fixed;
          bottom: 0px;
          right: 50px;
          z-index: 1;
          text-align: right;
        }
      }
    }
  }
</style>